import { axios } from '@Root/API'

export const edit = (contactId, formName, data) => {
	return axios.post(`hesa-detail/${contactId}/${formName}`, data)
}
